// extracted by mini-css-extract-plugin
export default {"layout":"ManageHomeLayout_layout__T1W-E","content":"ManageHomeLayout_content__bZACV"};